export enum EmployeeCommuteFrequency {
  Monthly = 'monthly',
  Annual = 'annual'
}